import React from 'react'

export default function Map() {
  return (
    <>
    <div class="map">
        <div class="col-sm-12 d-block d-md-none">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.0593614841478!2d88.43153237443353!3d22.576883032814976!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0275a58a5077e3%3A0xaca97a520d2c7f31!2sMerlin%20Matrix!5e0!3m2!1sen!2sin!4v1699356987622!5m2!1sen!2sin"
            style={{ border: "0" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </>
  )
}
